export default (name) => (a, b) => {
  /*console.log("Result for " + name + ":", {
    isSame: JSON.stringify(a) === JSON.stringify(b)
  });*/
  return JSON.stringify(a) === JSON.stringify(b);
}
